// extracted by mini-css-extract-plugin
export default {"wrapper":"ItemQuantity-module__wrapper___INUkI","label":"ItemQuantity-module__label___-p214"};